import * as React from 'react';
export const avalaraSvg = React.forwardRef(function avalaraSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F6F6',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.933 21.464c0 .004-1.194-1.44-1.891-2.218l-.988 2.298c1.418 2.085 2.356 3.884 2.872 4.743 1.006-1.683 3.456-6.678 8.54-11.351l-.56-1.308c-3.3 2.414-6.11 5.49-7.974 7.84',
      fill: '#059BD2',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27.318 27h-4.021l-2.232-5.248a37.701 37.701 0 0 1 2.707-3.214L27.319 27ZM17.68 4.001V4l3.691 8.802a38.442 38.442 0 0 0-2.975 2.664l-2.066-4.857-.33-.89h-.186l-.331.89L8.513 27H4.495l9.636-22.999h3.549Z',
      fill: '#FC6600',
    }),
  );
});
avalaraSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var avalara = {
  category: 'brand',
  colorable: false,
  name: 'avalara',
  svg: avalaraSvg,
};
